module.exports = __webpack_public_path__ + "img/m-hd.05a69e0f.jpg";